import { axiosDefaultInstance } from '@/http/default'

import type Company from '@/model/Company'
import type { CompanyRequest, Config } from '@/model/Company'
import type { EmployeeRequest } from '@/model/Employee'
import type { AxiosInstance } from 'axios'
import handleError from './util/ErrorHandler'
import type { ServiceError } from './util/ServiceError'


export interface CompanyRegistrationRequest {
  company: Omit<CompanyRequest, 'id'>
  employee: Omit<EmployeeRequest, 'id'>
}

class CompanyService {
  private axiosInstance: AxiosInstance


  constructor() {
    this.axiosInstance = axiosDefaultInstance
    // this.storeProfile = useProfileStore()
  }

  async findCompany(companyId: string): Promise<Company | ServiceError> {
    // this.storeProfile = useProfileStore()

    const params: string[][] = []
    const searchParams = new URLSearchParams(params)

    // const companyId: string = this.storeProfile.selectedCompany.id

    try {
      const networkResponse = await this.axiosInstance.get<Company>(
        `${import.meta.env.VITE_API_BASE_URL}/company/${companyId}`,
        { params: searchParams }
      )
      return networkResponse.data
    } catch (error) {
      return handleError(error)
    }
  }

  async updateConfig(companyId: string, config: Config): Promise<Company | ServiceError> {
    try {
      const networkResponse = await this.axiosInstance.put<Company>(
        `${import.meta.env.VITE_API_BASE_URL}/company/${companyId}/config`,
        config
      )
      return networkResponse.data
    } catch (error) {
      return handleError(error)
    }
  }

  async register(registrationData: CompanyRegistrationRequest): Promise<Company | ServiceError> {
    try {
      const networkResponse = await this.axiosInstance.post<Company>(
        `${import.meta.env.VITE_API_BASE_URL}/company/register`,
        registrationData
      )
      return networkResponse.data
    } catch (error) {
      return handleError(error)
    }
  }

}

export const companyService = new CompanyService()
